/**
 * Protected Route Component
 * Redirects unauthenticated users to login page
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * Protects routes that require authentication
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Protected content
 * @param {string} props.redirectTo - Redirect path for unauthenticated users
 */
const ProtectedRoute = ({ children, redirectTo = '/login' }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="page-loader">
        <LoadingSpinner size="large" />
        <p>Verifying authentication...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;
